import http from './http' // needs this file in the same directory

export default {
  index(params = {}){
    const queryParams = new URLSearchParams();

    // Paginação
    if (params.page) queryParams.append('page', params.page);
    if (params.per_page) queryParams.append('per_page', params.per_page);

    // Busca
    if (params.search) queryParams.append('search', params.search);

    // Filtros
    if (params.client_type) queryParams.append('client_type', params.client_type);

    // Ordenação
    if (params.sort_by) queryParams.append('sort_by', params.sort_by);
    if (params.sort_direction) queryParams.append('sort_direction', params.sort_direction);

    const queryString = queryParams.toString();
    const url = queryString ? `/clients?${queryString}` : '/clients';

    return http.get(url);
  },

  show(item_id){
    return http.get(`/clients/`+item_id);
  },

  create(new_item){
    // delete new_item.contracts.data.litigations
    // new_item.contracts.data = new_item.contracts.data.filter(obj => obj.name)
    // new_item.litigations.data = new_item.litigations.data.filter(obj => obj.name)

    return http.post(`/clients`,{
      client:{
        name: new_item.name,
        email: new_item.email,
        client_is: new_item.client_is,
        addresses: new_item.address,
        corporate_info: {
          corporate_name: new_item.corporate_name,
          state_inscription: new_item.state_inscription,
          city_inscription: new_item.city_inscription,
          responsible: new_item.responsible,
        },
        phones: new_item.phones,
        contracts_attributes: new_item.contracts.data.filter(obj => obj.name),
        litigations_attributes: new_item.litigations.data.filter(obj => obj.name),
        document_number: new_item.document_number,
      }
    });
  },

  update(update_item){
    console.log({update_item});
    // delete update_item.contracts.data.litigations
    // update_item.contracts.data = update_item.contracts.data.filter(obj => obj.name)
    // update_item.litigations.data = update_item.litigations.data.filter(obj => obj.name)

    return http.put(`/clients/${update_item.id}`,{
      client:{
        id: update_item.id,

        name: update_item.name,
        email: update_item.email,
        client_is: update_item.client_is,
        addresses: update_item.address,
        corporate_info: update_item.corporate_info,
        phones: update_item.phones,
        contracts_attributes: update_item.contracts.data.filter(obj => obj.name),
        litigations_attributes: update_item.litigations.data.filter(obj => obj.name),
        document_number: update_item.document_number,
      }
    });
  },

  updateToDelete(update_item){
    return http.delete(`/clients/${update_item}`);
  },

}